import { render, staticRenderFns } from "./RedBag.vue?vue&type=template&id=e1fe44f6&scoped=true"
import script from "./RedBag.vue?vue&type=script&lang=js"
export * from "./RedBag.vue?vue&type=script&lang=js"
import style0 from "./RedBag.vue?vue&type=style&index=0&id=e1fe44f6&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1fe44f6",
  null
  
)

export default component.exports